import { tokens } from "@/ui/theme/tamagui.config";
import { ColorToken } from "@/ui/theme/tokens";

const useColorToken = ({
  colorKey,
  fallback,
}: {
  colorKey: string;
  fallback?: string;
}) => {
  const allColors = Object.values(tokens.color);

  const colorValue = allColors.find((color) => color.key === colorKey);

  if (colorValue) {
    return colorValue.val;
  }

  if (fallback) {
    return fallback;
  }

  return tokens.color[ColorToken.NeutralPrimary].val;
};

export { useColorToken };
